import type { RefObject } from 'react'
import { applyChange, getLineBounds } from '../utils'

// Duplicate current line at given caret index and move caret to the same column on the duplicated line
export const duplicateLineAt = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
  caretIndex: number,
): void => {
  const { lineStart, lineEnd, line } = getLineBounds(value, caretIndex)

  const column = caretIndex - lineStart

  const isLastLine = lineEnd === value.length
  let before: string
  let after: string
  let insert: string
  let caret: number

  if (isLastLine) {
    before = value
    after = ''
    insert = `\n${line}`
    caret = value.length + 1 + column
  } else {
    before = value.slice(0, lineEnd + 1)
    after = value.slice(lineEnd + 1)
    insert = `${line}\n`
    caret = lineEnd + 1 + column
  }

  const next = `${before}${insert}${after}`
  applyChange(textareaRef, onChange, next, caret)
}

// Duplicate selection [start, end) and select the newly inserted duplicate
export const duplicateSelection = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
  start: number,
  end: number,
): void => {
  const before = value.slice(0, end)
  const selected = value.slice(start, end)
  const after = value.slice(end)

  const next = before + selected + after
  const ns = end
  const ne = end + selected.length
  applyChange(textareaRef, onChange, next, ns, ne)
}

export const duplicateAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
): void => {
  const el = textareaRef.current
  if (!el) return

  const s = el.selectionStart ?? 0
  const e = el.selectionEnd ?? s

  if (s === e) {
    duplicateLineAt(textareaRef, value, onChange, s)
  } else {
    duplicateSelection(textareaRef, value, onChange, s, e)
  }
}
